export default "__VITE_ASSET__K0HjYYGE__"